(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-gallery"] && !Shopify.designMode) return;
  try {
    
  class CustomerGallery {
    constructor(container) {
      this.container = container;
      this.trackContainer = container.querySelector('[data-track-container]');
      this.track = container.querySelector('[data-track]');
      this.items = [...this.track.querySelectorAll('.customer-gallery__item')];
      this.prevBtn = container.querySelector('[data-prev]');
      this.nextBtn = container.querySelector('[data-next]');
      this.dotsContainer = container.querySelector('[data-dots]');
      this.dots = this.dotsContainer ? [...this.dotsContainer.querySelectorAll('[data-dot]')] : [];

      this.init();
    }

    init() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scrollByItem(-1));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scrollByItem(1));
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToIndex(index));
      });

      this.trackContainer.addEventListener('scroll', () => this.updateNavState(), { passive: true });
      window.addEventListener('resize', () => this.updateNavState());

      this.observeActiveItem();
      this.updateNavState();
    }

    getStep() {
      const item = this.items[0];
      if (!item) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.offsetWidth + gap;
    }

    scrollByItem(direction) {
      this.trackContainer.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
    }

    scrollToIndex(index) {
      const item = this.items[index];
      if (!item) return;
      item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    observeActiveItem() {
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              const index = this.items.indexOf(entry.target);
              if (index !== -1) this.setActiveDot(index);
            }
          });
        },
        { root: this.trackContainer, threshold: [0.6] }
      );

      this.items.forEach((item) => observer.observe(item));
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;
      const maxScroll = this.trackContainer.scrollWidth - this.trackContainer.clientWidth - 1;
      this.prevBtn.disabled = this.trackContainer.scrollLeft <= 0;
      this.nextBtn.disabled = this.trackContainer.scrollLeft >= maxScroll;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.customer-gallery').forEach((el) => new CustomerGallery(el));
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const gallery = event.target.querySelector('.customer-gallery');
      if (gallery) new CustomerGallery(gallery);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vj-offers-carousel"] && !Shopify.designMode) return;
  try {
    
  class VjOffersCarousel {
    constructor(container) {
      this.container = container;
      this.wrapper = container.querySelector('.vj-offers-carousel__wrapper');
      this.trackContainer = container.querySelector('[data-track-container]');
      this.track = container.querySelector('[data-track]');
      this.slides = this.track ? [...this.track.querySelectorAll('[data-slide]')] : [];
      this.prevBtn = container.querySelector('[data-prev]');
      this.nextBtn = container.querySelector('[data-next]');
      this.dotsContainer = container.querySelector('[data-dots]');
      this.dots = this.dotsContainer ? [...this.dotsContainer.querySelectorAll('[data-dot]')] : [];

      this.currentIndex = 0;
      this.autoplayTimer = null;
      this.autoplay = this.wrapper && this.wrapper.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseFloat(this.wrapper && this.wrapper.dataset.autoplaySpeed) || 3) * 1000;
      this.pauseOnHover = this.wrapper && this.wrapper.dataset.pauseOnHover === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.init();
    }

    init() {
      if (!this.trackContainer || this.slides.length === 0) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.scrollByItem(-1);
          this.restartAutoplay();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.scrollByItem(1);
          this.restartAutoplay();
        });
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.scrollToIndex(index);
          this.restartAutoplay();
        });
      });

      this.trackContainer.addEventListener('scroll', () => this.updateNavState(), { passive: true });
      window.addEventListener('resize', () => this.updateNavState());

      // Pausar autoplay mientras el usuario interactúa manualmente (touch/mouse)
      if (this.pauseOnHover) {
        this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
        this.wrapper.addEventListener('mouseleave', () => this.startAutoplay());
      }
      this.trackContainer.addEventListener('pointerdown', () => this.stopAutoplay());
      this.trackContainer.addEventListener('pointerup', () => this.startAutoplay());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });

      this.observeActiveSlide();
      this.updateNavState();
      this.startAutoplay();
    }

    getStep() {
      const slide = this.slides[0];
      return slide ? slide.offsetWidth : 0;
    }

    scrollByItem(direction) {
      this.trackContainer.scrollBy({ left: this.getStep() * direction, behavior: 'smooth' });
    }

    scrollToIndex(index) {
      const slide = this.slides[index];
      if (!slide) return;
      /* VJ FIX: antes usaba slide.scrollIntoView(), que hace scroll en
         CUALQUIER ancestro con scroll — incluida la página completa — para
         garantizar visibilidad vertical del elemento. Si el carrusel estaba
         fuera de la vista (por ejemplo, la persona scrolleó más abajo), cada
         cambio automático de imagen saltaba la página entera hasta esta
         sección. Usamos scrollTo directo sobre el track horizontal, igual
         que scrollByItem, así el scroll queda contenido dentro del
         carrusel y nunca toca el scroll vertical de la página. */
      this.trackContainer.scrollTo({ left: this.getStep() * index, behavior: 'smooth' });
    }

    observeActiveSlide() {
      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              const index = this.slides.indexOf(entry.target);
              if (index !== -1) {
                this.currentIndex = index;
                this.setActiveDot(index);
              }
            }
          });
        },
        { root: this.trackContainer, threshold: [0.6] }
      );

      this.slides.forEach((slide) => observer.observe(slide));
    }

    setActiveDot(index) {
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    updateNavState() {
      if (!this.prevBtn || !this.nextBtn) return;
      const maxScroll = this.trackContainer.scrollWidth - this.trackContainer.clientWidth - 1;
      this.prevBtn.disabled = this.trackContainer.scrollLeft <= 0;
      this.nextBtn.disabled = this.trackContainer.scrollLeft >= maxScroll;
    }

    startAutoplay() {
      if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.scrollToIndex(nextIndex);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.vj-offers-carousel').forEach((el) => new VjOffersCarousel(el));
  });

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.target.querySelector('.vj-offers-carousel');
      if (carousel) new VjOffersCarousel(carousel);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
